import { render, staticRenderFns } from "./modal-pay-dialogue.vue?vue&type=template&id=b2bcf76a"
import script from "./modal-pay-dialogue.vue?vue&type=script&lang=js"
export * from "./modal-pay-dialogue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports